(function(){
    angular
        .module('app')
        .directive('ngAddckeditorall', addckeditorall);

        addckeditorall.$inject = ['$timeout'];
        function addckeditorall($timeout){
            return {
            require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    var value = $attrs.value;
                    var $element = $(element);
                    //console.log(scope);
                    var name = $element.attr("id");
                    //console.log(name);
                   
                    CKEDITOR.replace(name,{
						enterMode : CKEDITOR.ENTER_P,
						allowedContent : true,
						removeFormatAttributes:'',
						fullPage : true,
						height : '600px'

					})
					CKEDITOR.instances[name].on('change', function() {
                        //console.log("E");
                        scope.$apply(function(){
                            //console.log(scope.$parent);
                                ngModel.$setViewValue(CKEDITOR.instances[name].getData());
                        })
                    });
                    CKEDITOR.instances[name].on( 'mode', function() {
                        // Debugger.log('ckeditor mode change: '+ this.mode);
                        if ( this.mode == 'source' ) {
                            var editable = CKEDITOR.instances[name].editable();
                            editable.attachListener( editable, 'input', function() {
                                // Debugger.log('ckeditor source input change');
                                 CKEDITOR.instances[name].fire('change');
                            } );
                        }
                    } );
                });
            }
          }
      }
})();